<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        消防档案管理
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div
          class="btn"
          @click="searchShow"
          v-hasPermi="['basic:company:query']"
        >
          <i class="icon-tr-search"></i>查询
        </div>
        <router-link
          class="btn ml20"
          v-hasPermi="['basic:company:add']"
          v-if="area_account == '0' || area_account !== '1'"
          to="/company/company-add"
        >
          <i class="icon-tr-newly-added"></i>新增
        </router-link>
        <!-- <router-link class="btn ml20" v-if="area_account=='0'||area_account!=='1'" to="/company/group-add">
          <i></i>集团和园区单位管理
        </router-link> -->
      </div>
      <div class="common-page common-list">
        <el-table :data="list">
           <el-table-column
            prop="serialNo"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="c_name"
            label="单位名称"
            align="center"
          ></el-table-column>
         
          <el-table-column
            prop="c_address"
            align="center"
            label="详细地址"
          ></el-table-column>
          <!-- <el-table-column prop="mname" align="center" label="单位类型"></el-table-column> -->
          <el-table-column prop="cname" align="center" label="监管级别">
            <template slot-scope="scope">{{
              $map.jgjb[scope.row.c_safe_level]
            }}</template>
          </el-table-column>

          <el-table-column prop="tr_user_phone" align="center" label="状态">
            <template slot-scope="scope">{{
              $map.menuStatus[scope.row.status]
            }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="160px"
            v-hasPermi="['basic:company:edit']"
          >
            <template slot-scope="scope">
              <router-link
                v-hasPermi="['basic:company:edit']"
                :to="{
                  path: '/plan/manage',
                  query: { id: scope.row.c_company_num },
                }"
              >
                <el-button size="mini" type="warning">编辑</el-button>
              </router-link>
              <el-popconfirm
                title="确定禁用单位记录吗？"
                v-hasPermi="['basic:company:remove']"
                class="cursor"
                @onConfirm="changeStatus(scope.row, 0)"
                @confirm="changeStatus(scope.row, 0)"
              >
                <a slot="reference" class="red">
                  <el-button size="mini" type="danger">删除</el-button>
                </a>
              </el-popconfirm>
              <el-popconfirm
                v-if="scope.row.status == 0"
                title="确定启用此单位吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row, 1)"
                @confirm="changeStatus(scope.row, 1)"
              >
                <a slot="reference">
                  <el-button type="primary" size="mini">开启</el-button>
                </a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <!-- <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="showDia=false" size="small">取消</el-button>
      </div> -->
      <el-form
        ref="form"
        :model="params"
        label-width="110px"
        v-if="area_account == '2'"
      >
        <el-form-item label="单位名称" inline-message>
          <el-col>
            <el-input type="text" v-model="params.c_name"></el-input>
          </el-col>
        </el-form-item>
      </el-form>

      <el-form ref="form" :model="params" label-width="110px" v-else>
        <el-form-item label="单位名称" inline-message>
          <el-col>
            <el-input type="text" v-model="params.c_name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="单位地址" inline-message>
          <el-col>
            <el-input type="text" v-model="params.c_address"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="单位编号" inline-message>
          <el-col>
            <el-input type="text" v-model="params.c_number"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属行业" inline-message>
          <el-col>
            <!-- <el-input type="text" v-model="params.c_belong_profession"></el-input> -->
            <v-select
              :value.sync="params.c_belong_profession"
              :id="66"
            ></v-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="false" label="所属项目" inline-message>
          <!-- <el-checkbox-group  v-model="services" @change="handlechange">
              <el-checkbox label="1" key="评估">评估 </el-checkbox>
              <el-checkbox label="2" key="维保"> 维保</el-checkbox>
              <el-checkbox label="3" key="监控">监控</el-checkbox>
              <el-checkbox label="4" key="电检">电检</el-checkbox>

              <el-checkbox label="5" key="消检">消检</el-checkbox>
             </el-checkbox-group> -->
          <el-select v-model="params.item">
            <el-option
              v-for="item in prgromList"
              :value="item.uuid"
              :label="item.name"
              :key="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类型" inline-message>
          <!-- <el-checkbox-group  v-model="services" @change="handlechange">
              <el-checkbox label="1" key="评估">评估 </el-checkbox>
              <el-checkbox label="2" key="维保"> 维保</el-checkbox>
              <el-checkbox label="3" key="监控">监控</el-checkbox>
              <el-checkbox label="4" key="电检">电检</el-checkbox>

              <el-checkbox label="5" key="消检">消检</el-checkbox>
             </el-checkbox-group> -->
          <el-select v-model="params.c_port">
            <el-option value="1" key="评估" label="评估">评估</el-option>
            <el-option value="2" key="维保" label="维保">维保</el-option>

            <el-option value="3" key="监控" label="监控">监控</el-option>

            <el-option value="4" key="电检" label="电检">电检</el-option>

            <el-option value="5" key="消检" label="消检">消检</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="地区">
          <!-- <el-cascader :options="area" v-model="areaValue"
                                     @change="areaChange"
                                     :props="{value:'area_code',label:'area_name',children:'childArea'}"
                        >
                            <template slot-scope="{ node, data }">
                                <span>{{ data.area_name }}</span>
                            </template>
                        </el-cascader> -->
          <el-cascader
            :options="area"
            v-model="areaValue"
            @change="areaChange"
            :props="{
              value: 'areaCode',
              label: 'areaName',
              children: 'child',
            }"
          >
            <!-- <template slot-scope="scope">
              <span>{{ scope.areaName}}</span>
            </template> -->
          </el-cascader>
        </el-form-item>
      </el-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="canclesub" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyList, switchCompany } from "../../api/company";
export default {
  data() {
    return {
      list: [],
      area_account: "", // 1 ：代表普通单位 看自己不显示搜索框，2 ：文物市南，市北，只可以按着名称搜索，3：代表文物青岛 0代表管理员都显示
      area: [],
      areaValue: [],
      services: [],
      prgromList: [], // 项目选项
      params: {
        page: 1,
        c_number: "",
        c_name: "",
        c_address: "",
        c_belong_profession: "",
        c_belong_profession: "",
        area: "",
        c_port: "",
        item: "",
      },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("unitSearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    next((vm) => {
      if (vm.$store.state.user.userInfo.natureId == 2) {
        setTimeout(() => {
          vm.$router.push({
            path: "/plan/manage",
            query: { id: vm.$store.state.user.company.cCompanyNum },
          });
        });
      }
    });
  },
  created() {
    this.$get("/trmonitor/area/FatherSonLinkageList?threeLevel=4").then((res) => {
		console.log(res,'res');
      this.area = res.data;
    });
    this.$post("/dzda/listxiangmuNotPage").then((res) => {
      console.log(res);
      this.prgromList = res.data;
    });
    this.getList();
  },
  methods: {
    searchShow() {
      this.resetForms();
      this.showDia = true;
    },
    areaChange(val) {
      this.params.area = val[2];
    },
    handlechange() {
      this.params.c_port = this.services.join(",");
    },
    canclesub() {
      this.showDia = false;
      this.resetForms();
      this.getList();
    },
    changeStatus(it, status) {
      var id = it.c_id;
      var c_company_num = it.c_company_num;
      if (it.c_number == "aaa" && it.c_company_num == "aaa") {
        this.$message.error("管理员账号无法被删除");
        return false;
      }
      switchCompany({ c_id: id, status, c_company_num })
        .then((res) => {
          // this.$message.success("操作成功");
          this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      getCompanyList(this.params)
        .then((res) => {
          // console.log(res);
          this.total = res.count;
          this.list = res.list;
          this.area_account = res.area_account;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      // this.$refs.searchForm
      //   .getData()
      //   .then((data) => {
      //     //log(data)
      //     this.params = { ...this.params, ...data };
      //     this.getList();
      //     this.showDia = false;
      //   })
      //   .catch((e) => {});
      this.params.c_belong_profession = String(this.params.c_belong_profession);
      this.params.page = 1;

      this.getList(this.params);
      this.showDia = false;
    },
    resetForms() {
      this.params = {
        page: 1,
        c_number: "",
        c_name: "",
        c_address: "",
        c_belong_profession: "",
        c_belong_profession: "",
        area: "",
        c_port: "",
        item: "",
      };
      this.areaValue = [];
      this.services = [];
    },
    // resetSearch() {
    //   // this.$refs.searchForm.reset();
    //   // this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
    //   this.resetForms()
    //   this.getList();
    // },
  },
};
</script>

<style scoped></style>
